// extracted by mini-css-extract-plugin
export default {"fields":"BankPaymentModal-module--fields--fSuUs","footer":"BankPaymentModal-module--footer--ZEGct","deleteButton":"BankPaymentModal-module--deleteButton--p7OxX"};